import { callApi } from "./Api";
import qs from "qs";
import { push } from "react-router-redux";
import { actionCreator } from "./helpers";

export const SEGMENT_LIST = "SEGMENT_LIST";
export const SEGMENT_ARCHIVE = "SEGMENT_ARCHIVE";
export const ARCHIVE_SEGMENT = "ARCHIVE_SEGMENT";
export const CLEAR_REACTIVE_STATUS = "CLEAR_REACTIVE_STATUS";
export const REACTIVATE_SEGMENT = "REACTIVATE_SEGMENT";
export const IF_ARCHIVE_SUCCESS = "IF_ARCHIVE_SUCCESS";
export const GET_ATTRIBUTES = "GET_ATTRIBUTES";
export const COPY_SEGMENT = "COPY_SEGMENT";
export const SEGMENT_WITH_RULES = "SEGMENT_WITH_RULES";
export const CREATE_CAMPAIGN = "CREATE_CAMPAIGN";
export const ROLLBACK_VALUE = "ROLLBACK_VALUE";
export const CLEAR_SEGMENT_WITH_RULES = "CLEAR_SEGMENT_WITH_RULES";
export const SEARCH_BY_NAME = "SEARCH_BY_NAME";
export const SELECTED_SEGMENT = "SELECTED_SEGMENT";
export const RECORD_ACTIVE_QUERY_PARAMS = "RECORD_ACTIVE_QUERY_PARAMS";

export const clearSegmentWithRules = actionCreator(CLEAR_SEGMENT_WITH_RULES);
// when user select checkbox record the segment id
export const selectedSegment = actionCreator(SELECTED_SEGMENT);
// record the query params
export const recordActiveQueryParams = actionCreator(
  RECORD_ACTIVE_QUERY_PARAMS,
);

export const getSegmentList = (data = {}) => (dispatch, getState) => {
  let params = qs.stringify(data);
  let url = `segments/list?${params}`;
  callApi(dispatch, getState, SEGMENT_LIST, url);
};

export const archiveSuccess = actionCreator(IF_ARCHIVE_SUCCESS);
export const clearReactiveStatus = actionCreator(CLEAR_REACTIVE_STATUS);
export const rollbackRequestSuccessToFalse = actionCreator(ROLLBACK_VALUE);

export const reactiveSegment = id => (dispatch, getState) => {
  const url = `segments/restore/${id}`;
  callApi(dispatch, getState, REACTIVATE_SEGMENT, url, { method: "POST" });
};
export const archiveSegment = id => (dispatch, getState) => {
  let url = `segments/archive/${id}`;
  callApi(
    dispatch,
    getState,
    ARCHIVE_SEGMENT,
    url,
    {
      method: "POST",
    },
    {
      success: () => {
        dispatch(archiveSuccess(id));
      },
    },
  );
};

export const copySegment = id => (dispatch, getState) => {
  callApi(
    dispatch,
    getState,
    COPY_SEGMENT,
    "segments/copy",
    {
      method: "POST",
      body: JSON.stringify({ id }),
    },
    {
      success: () => {
        dispatch(push("/segment/create"));
      },
    },
  );
};

export const getSegmentWithRules = (id, cid) => (dispatch, getState) => {
  let url = `segments/${id}/with-rules`;
  callApi(
    dispatch,
    getState,
    SEGMENT_WITH_RULES,
    url,
    {},
    {
      success: () => {
        if (cid) {
          dispatch(push("/segments/builder?id=" + id + "&cid=" + cid));
        } else dispatch(push("/segments/builder?id=" + id));
      },
    },
  );
};

export const getSegmentArchiveData = (data = {}) => (dispatch, getState) => {
  let params = qs.stringify(data);
  let url = `segments/list?${params}`;
  callApi(dispatch, getState, SEGMENT_ARCHIVE, url);
};

export const getAttributes = id => (dispatch, getState) => {
  let url = `segments/${id}/segmentAttributes`;
  callApi(dispatch, getState, GET_ATTRIBUTES, url);
};

export const getCreateCampaign = (id, data) => (dispatch, getState) => {
  let url = `segments/${id}/audience-files`;
  callApi(dispatch, getState, CREATE_CAMPAIGN, url, {
    method: "POST",
    body: JSON.stringify(data),
  });
};

// search by name action
export const searchByName = obj => (dispatch, getState) => {
  let url = `segments/name-suggestions?keyword=${obj.keyword}&status=${obj.status}&clientId=${obj.clientId}`;
  if (obj.source) {
    url += `&source=${obj.source}`;
  }
  callApi(dispatch, getState, SEARCH_BY_NAME, url);
};



// WEBPACK FOOTER //
// ./src/actions/SegmentList.js